<!-- Checkout Top Bar -->
<div class="w-full border-b border-gray-200 bg-white">
  <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 bg-brocom-orange rounded-lg flex items-center justify-center">
          <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
          </svg>
        </div>
        <div>
          <h1 class="text-base sm:text-lg font-bold text-gray-900">{{ 'Składanie zamówienia' | translate }}</h1>
          <p class="text-xs text-gray-500 hidden sm:block">{{ 'Bezpiecznie i sprawnie' | translate }}</p>
        </div>
      </div>
      <div class="flex items-center gap-4 text-xs text-gray-500">
        <div class="flex items-center gap-1.5">
          <svg class="w-3.5 h-3.5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z">
            </path>
          </svg>
          <span class="hidden sm:inline">{{ 'Bezpieczne połączenie SSL' | translate }}</span>
        </div>
        <div class="flex items-center gap-1.5">
          <svg class="w-3.5 h-3.5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
          </svg>
          <span class="hidden sm:inline">{{ 'Dostawa FedEx' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="stepper-container" class="flex flex-col gap-8 sm:gap-10 px-4 sm:px-6 lg:px-8 mx-auto max-w-[1470px]">
  <div class="flex flex-col gap-6 pt-6 sm:pt-8">
    <app-stepper-header [currentStep]="currentStep" [steps]="steps"></app-stepper-header>
  </div>

  <p *ngIf="cartNotice" class="rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800"
    role="status" aria-live="polite">{{ cartNotice }}</p>

  <!-- Step Content -->
  <div [ngSwitch]="currentStep">
    <!-- Step 1: Shopping Basket -->
    <app-shopping-cart *ngSwitchCase="1" [cart]="cart" [appliedVoucher]="appliedVoucher"
      [voucherDiscountAmount]="voucherDiscountAmount" (quantityChange)="handleQuantityChange($event)"
      (deleteItemEmitter)="deleteItem($event)"></app-shopping-cart>

    <!-- Step 2: Login / Guest -->
    <app-login-guest-step *ngSwitchCase="2" (nextStepEmitter)="nextStep()"></app-login-guest-step>

    <!-- Step 3: Customer Details -->
    <app-billing-step *ngSwitchCase="3" [formGroup]="step2FormGroup"></app-billing-step>

    <!-- Step 4: Order Summary -->
    <app-order-summary-step *ngSwitchCase="4" [formGroup]="checkoutForm" [step4FormGroup]="step4FormGroup" [cart]="cart"
      [voucherDiscountAmount]="voucherDiscountAmount" [appliedVoucher]="appliedVoucher"
      [isProcessingOrder]="isProcessingOrder" [paymentError]="paymentError"
      (confirmOrder)="completeOrder()"></app-order-summary-step>

    <div *ngSwitchDefault>{{ 'Wybierz etap zamówienia' | translate }}</div>
  </div>

  <!-- Step Navigation -->
  <div class="px-4 sm:px-6 lg:px-8">
    <app-stepper-navigation [currentStep]="currentStep" [steps]="steps" [isNextDisabled]="isNextDisabled"
      (stepChangeEmitter)="handleStepChange($event)"></app-stepper-navigation>
  </div>
</div>